import { ProMailMigrationStatus } from '../mail_migration';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS = 'PRO_MAIL_MIGRATION_STATUS_';

export const ProMailMigrationStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.CANDIDATE}`]: 'Candidat',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.READY}`]: 'Prêt',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.BLOCKED}`]: 'Bloqué',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.PROVISIONING}`]: 'Provision en cours',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.DNS_PENDING}`]: 'DNS en propagation',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.SYNCING}`]: 'Copie en cours',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.FINAL_SYNC_SCHEDULED}`]:
      'Recopie finale planifiée',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.DONE}`]: 'Terminé',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.ERROR}`]: 'Erreur',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.ROLLING_BACK}`]: 'Annulation en cours',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS}${ProMailMigrationStatus.ROLLED_BACK}`]: 'Annulée',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  ProMailMigrationStatus,
  ProMailMigrationStatusTranslation,
  TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS,
  true,
);
